
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes, { object } from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Grid from '@mui/material/Grid';

import FullScreenDialog from "./../../../PopUp/FullScreendialogs"
import axios from 'axios';
import CustomBackdrop from '../../../Components/CustomBackdrop/Barckdrop';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { genURL } from '../../../_getjson';
import { Box } from '@mui/material';
export default function Csprepayment(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [Isload, setIsload] = useState(false)
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");

    const [deleteEnable, setdeleteEnable] = useState(true);
    const [rowSelect, setRowselect] = useState([]);
    useEffect(() => {
        componentdidmount()
    }, [])

    useEffect(() => {
        checkDeletebutton()
    }, [rowSelect])
    useEffect(() => {
        checkDeletebutton()
    }, [listitem])
    const componentdidmount = async () => {
        console.log("componentdidmount", parm);
        if (parm.tbCsapdeposit) {
            await setListitem(parm.tbCsapdeposit)
        }
        //  await loadeData()
    }

    const checkDeletebutton = () => {
        if (rowSelect.length > 0) {
            setdeleteEnable(false)
        } else {
            setdeleteEnable(true)
        }
    }
    const sendData = (e) => {
        let res = false
        if (e === true) {
            res = true
        }
        let resdatas = []
        resdatas.push(res)
        resdatas.push("Csapdeposit") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(listitem)
        props.resdata(resdatas)
    }
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = async (e) => {
        var row = listitem
        console.log("ReturnDatalistitem", e[2]);
        var j = listitem.length
        if (e) {
            for (let i = 0; i < e[2].length; i++) {
                row[j] = {
                    DEPOSITNO: e[2][i].DEPOSITNO,
                    DEBTAMOUNT: e[2][i].DEBTAMOUNT,
                    PLAYAMOUNT: e[2][i].DEBTAMOUNT,
                    DEBTBALANCE: e[2][i].DEBTBALANCE,
                    EXCHANGERATE: e[2][i].EXCHANGERATE
                }
                j++
            }
        }
        setListitem(row)
        setTimeout(() => {
            sendData(true)
        }, 500);
    }
    const SelAPDepositUse = async (e) => {
        console.log(parm.APCode);
        var docno = ""
        console.log(listitem);
        for (let i = 0; i < listitem.length && listitem[i].DEPOSITNO; i++) {
            docno += await listitem[i].DEPOSITNO + "|"
        }
        console.log(docno);
        let arrforparm = []
        arrforparm = {
            APCode: await parm.APCode,
            docno: await docno
        }
        setdataMultipletax(await arrforparm)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog("ค้นหาใบจ่ายเงินมัดจำ-SelAPDepositUse")
        settypeFullScreenDialog(e)

    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }

    //--------------------------------เช็คเลือกข้อมูล--------------------------------
    const selectRowProp = {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: onRowSelect,
        onSelectAll: onSelectAll
    };

    function onRowSelect(rows, isSelected, e) {
        if (isSelected === true) {
            setRowselect(rowSelect => [...rowSelect, rows.DEPOSITNO])
        } else if (isSelected === false) {
            setRowselect(current => current.filter(obj => {
                return obj !== rows.DEPOSITNO
            }))
        }
    }
    function onSelectAll(isSelected, rows) {

        console.log("onSelectAll", rows, "isSelected", isSelected)

        if (isSelected === true) {
            for (let i = 0; i < rows.length; i++) {
                setRowselect(rowSelect => [...rowSelect, rows[i].DEPOSITNO])
            }
        } else if (isSelected === false) {
            for (let i = 0; i < rows.length; i++) {
                setRowselect(current => current.filter(obj => {
                    return obj !== rows[i].DEPOSITNO
                }))
            }
        }
    }
    const cellEditProp = {
        mode: 'click',
        blurToSave: true,
        // afterSaveCell: this.afterSaveCell,
        blurToSave: true,
    }
    //--------------------------------end เช็คเลือกข้อมูล--------------------------------



    // ลบแถวในตาราง
    const deleteRowsClick = async () => {

        console.log("deleteRowsClick", rowSelect);

        for (let index = 0; index < rowSelect.length; index++) {
            deleteRowsData(rowSelect[index])
        }
    }

    const deleteRowsData = async (e) => {
        await setListitem(current => current.filter(obj => {
            return obj.DEPOSITNO !== e
        }))

        await setRowselect(rowSelect => rowSelect.filter(obj => {
            console.log("setRowselect", obj, "e", e, "sssssssss", obj !== e)
            return obj !== e
        }))

        await console.log("setRowselect", rowSelect)
    }

    return (
        <div className="panel-body DivTable">
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            {/* <button onClick={sendData}>ตกลง</button> */}
            <Box display="flex" justifyContent="flex-start" m={1} pb={1} >
                <ButtonGroup aria-label="outlined inherit button group"  >
                    <Button size='small' onClick={sendData} color="inherit" variant="contained"> ตกลง </Button>
                    <Button size='small' disabled={deleteEnable} onClick={_ => deleteRowsClick()} color="inherit" variant="contained">ลบ</Button>
                </ButtonGroup>
            </Box>

            <BootstrapTable
                data={listitem}
                options={{
                    // onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                cellEdit={cellEditProp}
                height='500'
                selectRow={selectRowProp}
            >
                <TableHeaderColumn dataAlign="center" width="30" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DEPOSITNO' dataAlign="center" editable={false} isKey> ใบรับเงินมัดจำ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='DEBTAMOUNT' dataAlign="left" editable={false}> คงเหลือ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='PLAYAMOUNT' dataAlign="left" editable={true} > ยอดชำระ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='DEBTBALANCE' dataAlign="left" editable={false}> ไม่รวม VAT </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='EXCHANGERATE' dataAlign="left" editable={false}> อัตราแลกเปลี่ยนเดิม </TableHeaderColumn>
            </BootstrapTable>

            <Box display="flex" justifyContent="center" m={1} p={1} >
                <ButtonGroup aria-label="contained inherit button group">
                    <Button size='small' onClick={() => SelAPDepositUse("SelAPDepositUse")} variant="contained" color="inherit">เลือกเอกสาร</Button>
                    <Button size='small' onClick={() => sendData()} variant="contained" color="inherit"> ตกลง </Button>
                </ButtonGroup>
            </Box>




            <CustomBackdrop open={Isload} />
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
        </div >)
}
Csprepayment.prototype = {
    parm: PropTypes.array,
}
